module.exports = __webpack_public_path__ + "static/media/alladin3.7fd6b9cd.gif";